export const getOriginPage = () => {
  if (typeof window !== "undefined") {
    const { pathname } = window.location

    if (pathname === "/") {
      return "home_page"
    }

    if (pathname.includes("category")) {
      return "category_page"
    }

    if (pathname.includes("author")) {
      return "author_page"
    }
  }

  return "unknown_page"
}
